import { defineMessages } from 'react-intl';

export const yakliMessages = defineMessages({
  subtitlePrefix: { defaultMessage: 'Lié au sujet :', id: 'ngnvGX' },
  allDiscussions: { defaultMessage: 'Toutes les discussions', id: 'bYqNpk' },
  uniqueDiscussion: { defaultMessage: 'Discussion unique', id: 'NNbl0n' },
  copySuccess: { defaultMessage: 'Le lien vers le message a été copié.', id: 'BYB5Q2' },
  discussionPageName: { defaultMessage: 'Discussion', id: '20bImY' },
});
